import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const fileUrl = (relative) => `${BACKEND_URL}${relative}`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("ms_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const getProducts = () => client.get("/products").then((r) => r.data);
export const getProduct = (slug) => client.get(`/products/${slug}`).then((r) => r.data);
export const uploadLogo = (formData) =>
  client.post("/upload", formData, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
export const createOrder = (payload) => client.post("/orders", payload).then((r) => r.data);
export const login = (email, password) => client.post("/auth/login", { email, password }).then((r) => r.data);
export const getMe = () => client.get("/auth/me").then((r) => r.data);
export const getOrders = () => client.get("/orders").then((r) => r.data);
export const getStats = () => client.get("/stats").then((r) => r.data);
export const updateOrderStatus = (id, status) => client.patch(`/orders/${id}`, { status }).then((r) => r.data);
export const sendChat = (session_id, message) => client.post("/chat", { session_id, message }).then((r) => r.data);
export const generateCopy = (payload) => client.post("/admin/generate-copy", payload).then((r) => r.data);

export const priceForQuantity = (tiers, qty) => {
  const applicable = tiers.filter((t) => qty >= t.min_qty);
  if (!applicable.length) return tiers[0].price;
  return applicable.reduce((a, b) => (b.min_qty > a.min_qty ? b : a)).price;
};

export default client;
